import { defineMessages } from 'react-intl';

export default defineMessages({
    welcomeToOnlineInsurance: {
        id: 'ml.quoteandbind.common.StartQuote.Get a quote for insurance to protect what really matters',
        defaultMessage: 'Get a quote for insurance to protect what really matters'
    },
    insuranceDesignedEspesciallyForYou: {
        id: 'ml.quoteandbind.common.StartQuote.Insurance designed especially for you',
        defaultMessage: 'Insurance designed especially for you.'
    },
    totallyConvenientTotallyOnline: {
        id: 'ml.quoteandbind.common.StartQuote.Totally convenient totally online',
        defaultMessage: 'Totally convenient. Totally online.'
    },
    zipCode: {
        id: 'ml.quoteandbind.common.StartQuote.ZIP Code',
        defaultMessage: 'ZIP Code'
    },
    StartQuoteLink: {
        id: 'integration.quoteandbind.Link',
        defaultMessage: 'Retrieve Existing Quote'
    },
    autoBtn: {
        id: 'ml.quoteandbind.common.StartQuote.AUTO',
        defaultMessage: 'AUTO'
    },
    homeBtn: {
        id: 'ml.quoteandbind.common.StartQuote.HOME',
        defaultMessage: 'HOME'
    },
    renters: {
        id: 'ml.quoteandbind.common.StartQuote.Renters',
        defaultMessage: 'Renters'
    },
    rentersBtn: {
        id: 'ml.quoteandbind.common.StartQuote.RENTERS (BUNDLE)',
        defaultMessage: 'RENTERS (BUNDLE)'
    },
    condo: {
        id: 'ml.quoteandbind.common.StartQuote.Condo',
        defaultMessage: 'Condo'
    },
    condoBtn: {
        id: 'ml.quoteandbind.common.StartQuote.CONDO (BUNDLE)',
        defaultMessage: 'CONDO (BUNDLE)'
    },
    umbrellaBtn: {
        id: 'ml.quoteandbind.common.StartQuote.UMBRELLA',
        defaultMessage: 'UMBRELLA'
    },
    getQuoteBtn: {
        id: 'ml.quoteandbind.common.StartQuote.GET A QUOTE',
        defaultMessage: 'GET A QUOTE'
    },
    addedProducts: {
        id: 'ml.quoteandbind.common.StartQuote.Added Products',
        defaultMessage: 'Added products:'
    },
    retrieveExistingQuote: {
        id: 'ml.quoteandbind.common.StartQuote.Retrieve Existing Quote',
        defaultMessage: 'Retrieve Existing Quote'
    },
    bundleSaveTitle: {
        id: "ml.quoteandbind.common.StartQuote.Bundle and Save",
        defaultMessage: "Bundle and Save"
    },
    bundleSaveSubTitle: {
        id: "ml.quoteandbind.common.StartQuote.Bundle and Save First Text",
        defaultMessage: "Purchase multiple policies and unlock additional discounts!"
    },
    bundleSaveDescription: {
        id: "ml.quoteandbind.common.StartQuote.Bundle and Save Second Text",
        defaultMessage: "Customers who bundle often save hundreds while getting great coverage."
    },
});
